module.exports = __webpack_public_path__ + "media/ecom/bubbles-cdcda34d.svg";